/* eslint-disable react/require-default-props,jsx-a11y/label-has-for */
import PropTypes from 'prop-types';
import React from 'react';
import { fieldPropTypes } from 'redux-form';
import formClassName from '../../../../shared/helpers/formClassName';

const TextArea = ({
  required,
  input,
  inputID,
  label,
  labelClassName,
  inputClassName,
  placeholder,
  disabled,
  rows,
  hidden,
  meta: { touched, error, warning },
}) => {
  if (hidden) {
    return null;
  }
  return (
    <div className={formClassName(
      false,
      touched,
      false,
      error,
      disabled,
      warning,
    ).formErrorClass}
    >
      {label && (
        <label htmlFor={inputID} className={labelClassName}>
          {label}
          {' '}
          {required && <span className="requiredField">*</span>}
        </label>
      )}
      <div className={inputClassName}>
        <textarea
          className={`form-control ${formClassName(
            false,
            touched,
            false,
            error,
            disabled,
            warning,
          ).validationFeedback}`}
          {...input}
          placeholder={placeholder || (required ? 'required' : '')}
          id={inputID}
          disabled={disabled}
          rows={rows}
        />
        {touched
        && ((error && <div className="invalid-feedback">{error}</div>))}
      </div>
    </div>
  );
};

TextArea.propTypes = {
  // eslint-disable-next-line react/no-typos
  input: fieldPropTypes.input,
  label: PropTypes.string,
  // eslint-disable-next-line react/no-typos
  meta: fieldPropTypes.meta,
  required: PropTypes.bool,
  inputID: PropTypes.string,
  placeholder: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  rows: PropTypes.number,
};
TextArea.defaultProps = {
  label: null,
  required: false,
  inputID: null,
  placeholder: null,
  labelClassName: 'text-left col-12',
  inputClassName: 'col-12',
  disabled: false,
  hidden: false,
  rows: null,
};

export default TextArea;
